const isSubtitleText = (name?: string): boolean => {
  if (!name) return false;

  return name.startsWith("sub-");
};

export default isSubtitleText;
